import React  from 'react'


export default class TestComponentForUrlBasedPages extends React.Component 
{
    static defaultProps={

    };

    constructor(props) 
    {
        super(props);
        this.state = {
        };
    }

    componentDidMount() 
    {
        
    }

    render()
    {
        return (
            <div className="contentwrapper">
                <div>This is a test component. Don't remove it.</div>
            </div>
        );
    }
}

